<template>
  <div class="t-reviews-list">
    <cmp-reviews v-for="(item, index) in reviews.items" :key="'reviews_' + index" :data="item"></cmp-reviews>
  </div>
</template>

<script>
    import {store} from '../../../store/index'

    import {mapGetters, mapActions} from 'vuex'

    import Reviews from '../../../vue_components/Reviews.vue'

    export default {
        components: {
            'cmp-reviews': Reviews
        },
        computed: {
            ...mapGetters('coursesList', ['reviews', 'course'])
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Load(){
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter (to, from, next) {
            let count = 0;
            store.dispatch('staticText/LoadReviewText').then(() => {count++;RunNext();});
            store.dispatch('coursesList/LoadReviews', {id: to.params.id}).then(() => {
                count++;
                RunNext();
            });
            let RunNext = () => {
                if(count > 1)
                    next(vm => vm.Load())
            }
        }
    }
</script>

<style lang="sass">
.t-reviews-list
  display: flex
  align-items: stretch
  justify-content: flex-start
  flex-wrap: wrap
  margin: 0 -64px 0 0
@media(max-width: 769px)
  .t-reviews-list
    padding: 0 16px
    margin: 0
</style>


// WEBPACK FOOTER //
// src/vue_pages/Courses/View/Reviews.vue